import { observer } from 'mobx-react-lite'
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from '../components/ErrorMessage'
import agent from '../../app/api/agent'

function ForgetPassword({ close }: any) {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loadingBtn, setLoadingBtn] = useState(false)

  function handleResetPassword() {
    setLoadingBtn(true)
    agent.Profile.sendForgotPassword(email)
      .then(() => {
        toast.success(t('password_reset_succes'))
        close(false)
        setError('')
      })
      .catch((error) => {
        setError(error.response.data)
      })
      .finally(() => setLoadingBtn(false))
  }

  const buttons = [
    {
      title: t('cancel'),
      className: 'text-white payment-button-cancel',
      type: 'button',
      onClick: () => {
        close(false)
        setError('')
        setEmail('')
      },
    },
    {
      title: t('send'),
      className: 'text-white payment-button-tryagain',
      onClick: handleResetPassword,
    },
  ]

  return (
    <Card className="newFont prevent-select">
      <Modal.Header>
        <p className="login-card-title">{t('reset_password')}</p>
        <Button variant="inherit" onClick={close} className="close me-2">
          <i className="fa-regular fa-x icon-size" />
        </Button>
      </Modal.Header>
      <Modal.Body className="card-padding card-font-size">
        <Form>
          <Form.Group className="mb-3 profile-password">
            <p className="mb-3">{t('reset_password_desc')}</p>
            <div className="input-group input-group-sm mb-3 pt-3">
              <Form.Control
                type="text"
                name="email"
                className="card-input-style"
                placeholder="example@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </Form.Group>
          {error && typeof error === 'string' && (
            <ErrorMessage text={t(error)} setError={() => setError('')} />
          )}
          <div className="forget-create-buttons">
            {buttons.map((button) => (
              <button
                key={button.title}
                disabled={loadingBtn}
                onClick={button.onClick}
                type={button.type === 'submit' ? 'submit' : 'button'}
                className={`text-white ${button.className}`}
              >
                {loadingBtn && button.title === t('send') ? (
                  <Spinner animation="border" variant="light" />
                ) : (
                  button.title
                )}
              </button>
            ))}
          </div>
        </Form>
      </Modal.Body>
    </Card>
  )
}
export default observer(ForgetPassword)
